import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { channelsRoute } from './routes';
import { channelPromoBlockWidget } from './widgets';
import { ChannelPromoBlock } from './components/ChannelPromoBlock/ChannelPromoBlock';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: channelsRoute,
        meta: {
            plusPaymentPage: 'ChannelPage',
            page: 'channels',
        },
        component: lazy(() => import('./components/ChannelsPage/ChannelsPage')),
        fallback: RouteSkeleton,
    });

    ctx.addWidget({
        widget: channelPromoBlockWidget,
        component: ChannelPromoBlock,
    });
});

export * from './routes';
export * from './widgets';

export default scenario;
